import { isLiveChatInvitationNotificationDetails as typeGuard } from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationLiveChatInvitation.vue";

export const selector = (item: Notification): boolean => {
  return typeGuard(item.details);
};
